import { makeObservable, observable } from "mobx"

import { LcAddress } from "@/domains/core"

import type { IManualClPoolRepository } from "./interfaces"
import { ManualClPoolStore } from "./manual-cl-store"

export class ManualClPoolRepository implements IManualClPoolRepository {
  pools = new Map<string, ManualClPoolStore>()

  constructor() {
    makeObservable(this, {
      pools: observable,
    })
  }

  // Add pool to repository
  add(pool: ManualClPoolStore): void {
    const existing = this.find(pool.address)
    if (existing) {
      return
    }

    this.pools.set(pool.address.toString(), pool)
  }

  // Simple find method - returns actual ManualClPoolStore instance
  find(address: LcAddress): ManualClPoolStore | undefined {
    return this.pools.get(address.toString())
  }

  // Get all pools
  getAll(): ManualClPoolStore[] {
    return Array.from(this.pools.values())
  }

  // Get active pools only
  getActivePools(): ManualClPoolStore[] {
    return this.getAll().filter((pool) => pool.tvlUsd > 0)
  }

  // Get pools by tag
  getPoolsByTag(tag: string): ManualClPoolStore[] {
    return this.getAll().filter((pool) => pool.tags.includes(tag))
  }

  get totalPools(): number {
    return this.pools.size
  }

  get totalTvlUsd(): number {
    return Array.from(this.pools.values()).reduce((total, pool) => {
      return total + pool.tvlUsd
    }, 0)
  }

  clearAllUserValues(): void {
    this.pools.forEach((pool) => {
      pool.onChainUserBalance = 0n
      pool.onChainUserBalanceToken0 = 0n
      pool.onChainUserBalanceToken1 = 0n
    })
  }
}
